module.exports = "/img/10.a36f98.webp";